export const areThereProductsWithoutEnoughStock = (cart) => {
  return cart?.lineItems.some((item) => {
    return item.quantity > item.variant?.availability?.availableQuantity;
  });
};

export const areThereCartsWithoutEnoughStock = (upToDateCarts) => {
  return upToDateCarts.some(areThereProductsWithoutEnoughStock);
};
